
riot.tag2('add-fields-list', '  <div class="row">\n    <div class="col-md-3">\n      <add-fields-groups type="{opts.type}"></add-fields-groups>\n    </div>\n    <div class="col-md-9">\n      <catalog object="CustomField" cols="{cols}" reload="true" handlers="{handlers}" filters="{filters}" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="enabled"><i class="fa {row.enabled == 1 ? &quot;fa-check-circle-o&quot; : &quot;fa-circle-o  text-muted&quot;} "></i></datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="type">{handlers.types[row.type]}</datatable-cell>\n          <datatable-cell name="required">{row.required == 0 ? \'Нет\' : \'Да\'}</datatable-cell>\n          <datatable-cell name="placeholder">{row.placeholder}</datatable-cell>\n          <datatable-cell name="description">{row.description}</datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'CustomField';

self.filter = [{
    field: 'data',
    value: opts.type }];

self.filters = [].concat(self.filter);

self.addEdit = function (e) {
    var id = void 0;

    if (e.item && e.item.row) id = e.item.row.id;

    modals.create('add-fields-edit-modal', {
        type: 'modal-primary',
        id: id,
        data: opts.type,
        submit: function submit() {
            var _this = this;
            _this.error = _this.validation.validate(_this.item, _this.rules);
            var item = _this.item;

            if (opts.type) item = (0, _extends3.default)({}, this.item, { data: opts.type });

            if (!_this.error) {
                API.request({
                    object: 'CustomField',
                    method: 'Save',
                    data: item,
                    success: function success(response) {
                        popups.create({
                            title: 'Успех!',
                            text: 'Дополнительное поле сохранено!',
                            style: 'popup-success'
                        });
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};

self.cols = [{ name: 'id', value: '#' }, { name: 'enabled', value: 'Активно' }, { name: 'code', value: 'Код' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип переменной' }, { name: 'required', value: 'Обязательное' }, { name: 'placeholder', value: 'Подсказка' }, { name: 'description', value: 'Описание' }];

self.handlers = {
    types: {
        string: 'Строка',
        number: 'Число',
        text: 'Текст',
        select: 'Список',
        checkbox: 'Флажок',
        radio: 'Переключатель',
        date: 'Дата'
    }
};

self.one('updated', function () {
    var datatable = self.tags['add-fields-groups'].tags['catalog'].tags.datatable;
    datatable.on('row-selected', function (count, row) {
        var items = datatable.getSelectedRows();

        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.id;
            }).join(',');
            self.filters = [{ field: 'idGroup', sign: 'IN', value: value }].concat(self.filter);
        } else {
            self.filters = [].concat(self.filter);
        }

        self.update();
        self.tags.catalog.reload();
    });
});
});


// WEBPACK FOOTER //
// ./pages/settings/add-fields/add-fields-list.tag